import { render, staticRenderFns } from "./step_description_lizing.vue?vue&type=template&id=4bc889b1&scoped=true"
import script from "./step_description_lizing.vue?vue&type=script&lang=js"
export * from "./step_description_lizing.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4bc889b1",
  null
  
)

export default component.exports